const config = require("../config");

const localeData = require("../../locales");

if (!config.isDevelopment) {
    localeData.supportedLocales = ["en"];
}

type LocaleResources = typeof localeData.resources;

export const resources: LocaleResources = localeData.resources;

export type SupportedLocale = Extract<keyof LocaleResources, string>;

export const DEFAULT_LOCALE: SupportedLocale = localeData.defaultLocale as SupportedLocale;

export const DEFAULT_NAMESPACES = localeData.namespaces as ReadonlyArray<string>;

export const SUPPORTED_LOCALES: SupportedLocale[] = localeData.supportedLocales as SupportedLocale[];
